/**
 * Cloison
 */
import * as THREE from "three";
import Experience from "../../Experience.js";

export default class Partition {
  constructor(
    scale,
    position = new THREE.Vector3(0, 0, 0),
    srcTexture = null,
    rotation
  ) {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.scale = scale;
    this.length = this.scale.x;
    this.height = 2.5;
    this.thickness = 0.1;
    this.rotation = rotation || new THREE.Euler(0, 0, 0);

    this.position = position;
    this.srcTexture = srcTexture;

    this.textureLoader = this.experience.textureLoader;


    this.normalTexture = this.textureLoader.load(
      "./products/wall/normalMap.jpg"
    );

    this.normalTexture.repeat.set(this.length / 3.5, 0.85);
    this.normalTexture.wrapS = THREE.RepeatWrapping;
    this.normalTexture.wrapT = THREE.RepeatWrapping;

    this.objectManager = this.experience.objectManager;

    this.material = [
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // +X
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // -X
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // +Y
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // -Y
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // +Z (intérieur)
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // -Z
    ];

    this.geometry = new THREE.BoxGeometry(
      this.length,
      this.height,
      this.thickness
    );

    this.geometry.translate(0, this.height / 2, 0);

    // Creation partition
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.position.copy(this.position);
    this.mesh.userData.collision = true;
    this.mesh.userData.snapping = false;
    this.mesh.name = "partition";
    this.mesh.userData.type = "partition";
    this.mesh.userData.instance = this;
    this.mesh.userData.scale = this.scale;
    this.mesh.userData.model = this.mesh;
    this.mesh.userData.isBoxGeometry = true;


    if (this.rotation) {
      this.mesh.rotation.copy(this.rotation);
    }

    if (this.srcTexture !== null) {
      this.setTexture(this.srcTexture);
    }

    this.objectManager.addObjectCollision(this.mesh);
    this.objectManager.addObject(this.mesh);

    this.scene.add(this.mesh);
  }

  /**
   * Set length of partition
   * @param {number} newLength - New length of partition.
   */
  setLength(newLength) {
    this.length = newLength;
    this.geometry.dispose();
    this.geometry = new THREE.BoxGeometry(
      this.length,
      this.height,
      this.thickness
    );
    this.mesh.geometry = this.geometry;
  }

  setTexture(textureUrl) {
    this.textureLoader.load(
      textureUrl,
      (texture) => {
        texture.colorSpace = THREE.SRGBColorSpace;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(this.length / 3.5, 0.85);

        // Change side
        this.material[0] = new THREE.MeshStandardMaterial({ map: texture, normalMap: this.normalTexture });
        this.material[1] = new THREE.MeshStandardMaterial({ map: texture, normalMap: this.normalTexture });
        this.material[2] = new THREE.MeshStandardMaterial({ map: texture, normalMap: this.normalTexture });
        this.material[3] = new THREE.MeshStandardMaterial({ map: texture, normalMap: this.normalTexture });
        this.material[4] = new THREE.MeshStandardMaterial({ map: texture, normalMap: this.normalTexture });
        this.material[5] = new THREE.MeshStandardMaterial({ map: texture, normalMap: this.normalTexture });

        // Update material
        this.mesh.material = this.material;
        this.mesh.userData.texture = textureUrl;
      },
      undefined,
      (error) => {
        console.error("Erreur lors du chargement de la texture :", error);
      }
    );
  }

  /**
   * Function for duplicate object
   */
  cloneInstance() {
    const clonedInstance = new Partition(
      this.scale.clone(), // scale
      new THREE.Vector3(0, 0, 0), //  position
      this.mesh.userData.texture,
      null
    );
    return clonedInstance;
  }
}
